import * as React from 'react'
import { Field, reduxForm } from 'redux-form'
import Moment from 'moment';
//import 'moment/locale/es-us';
//import 'moment/locale/es';

var langdata: any;

var LangValidations: any = localStorage.getItem("LangResourcesValidations") || ""
if (LangValidations == "undefined") {
    var initmessage: any = "{\"invalidemail\":\"Invalidemailaddress\",\"required\":\"Required\",\"invalidpassword\":\"Invalidpassword\",\"yourcardincomplete\":\"Yourcardnumberisincomplete.\",\"cardexperation\":\"Yourcard'sexpirationdateisincomplete.\",\"cardsecurity\":\"Yourcard'ssecuritycodeisincomplete.\",\"userdobrange\":\"Ageshouldbeabove\",\"pleaseselctfile\":\"Pleaseselectfiles\",\"selectdateandtime\":\"Pleaseselectadateandtimetocontinue\",\"invalidcode\":\"Invalidcode\",\"selectpaymethod\":\"Pleaseselectpaymethodtoproceed\",\"uploadsuccessfully\":\"Uploadedsuccessfully\",\"areyousuretodelete\":\"Areyousuretodelete?\",\"deletedsuccessfully\":\"Deletedsuccessfully\",\"insurancinactive\":\"Areyousuretoinactivatetheinsurance?\",\"insuranceactive\":\"Areyousuretoactivatetheinsurance?\",\"nochanges\":\"Nochanges\",\"successfuly\":\"Savedsuccessfully\",\"changedsuccessfully\":\"Changedsuccessfully\",\"profilepictureupdate\":\"ProfilePictureUpdatedSuccessfully\",\"pharmacypostalcode\":\"PleaseselectStateorEnteravalidCityorPostalcode\",\"passwordsdonotmatch\":\"Passwordsdonotmatch\",\"mustbe\":\"Mustbe\",\"charactersorless\":\"charactersorless\",\"charactersormore\":\"charactersormore\",\"mustbeanumber\":\"Mustbeanumber\",\"mustbeatleast\":\"Mustbeatleast\",\"invalidphonenumbermustbe\":\"Invalidphonenumber,mustbe\",\"digits\":\"digits\",\"invalidzipcode\":\"Invalidzipcode\",\"years\":\"Years\",\"invalidinvitationcode\":\"Invalidinvitationcode\",\"updatedsuccessfully\":\"Updatedsuccessfully\",\"pleaseselectspeciality\":\"Pleasechooseaspecialtytoproceed\",\"appointmentalreadybooked\":\"AppointmentAlreadyBooked\",\"entervalidemail\":\"EnterValidEmail\",\"appointmentcancelledsuccesfully\":\"AppointmentCancelledSuccessfully\",\"loading\":\"Loading\",\"pastappointment\":\"Appointmentcannotbescheduledforpastdatesandtime\",\"messagesubmittedsuccesfully\":\"Yourmessagehasbeensubmittedsuccessfully\",\"existinginsurancepolicyisalreadyactive\":\"Existinginsurancepolicyisalreadyactive\",\"theusernameorpasswordisincorrect\":\"Theusernameorpasswordisincorrect\",\"emailalreadyexists\":\"Emailalreadyexists\",\"pleaseselectvalidcity/state\":\"Pleaseselectvalidcity/state\",\"invalidcurrentpassword\":\"Invalidcurrentpassword\",\"pleaseselectfilesize\":\"PleaseselectJPG,GIForPNG\",\"somethingwentwrong\":\"Somethingwentwrong\",\"invaliddate\":\"Invaliddate\",\"pleaseselectimagesize\":\"Pleaseselectimagesizelessthan2MB\",\"pleaseselectafilewithaspectratio\":\"Imagesizeistoosmall,pleaseselectafilewithaspectratiogreaterthan150*150*px\",\"nomatchesfound\":\"Nomatchesfound.\",\"searching\":\"Searching...\",\"typetosearch\":\"Typetosearch...\",\"allowedfiletypes\":\"Allowedfiletype(s)are\",\"pleasecheckthefiletypeandupload\":\"Pleasecheckthefiletypeandupload\",\"maximumfilesizeexceed\":\"Maximumfilesizeexceeded.Pleasecheckthefilesizeandupload\"}"
    LangValidations = initmessage;
    localStorage.setItem("LangResourcesValidations", initmessage);
}
if (LangValidations && LangValidations != null && LangValidations !== undefined)
    langdata = JSON.parse(localStorage.getItem("LangResourcesValidations") || "");


//export const required = (value: string) => (value || typeof value === 'number' ? undefined : langdata['required'] == undefined ? '' : langdata['required'])
//export const required = (value: string) => value || typeof value === 'number' ? undefined : langdata && langdata['required'] ? langdata['required'] : '';

/*console.log(langdata)*/
export const required = (value: string) => {
    if (localStorage.getItem("LangResourcesValidations") != null)
        langdata = JSON.parse(localStorage.getItem("LangResourcesValidations") || "");
    if (!langdata || langdata['required'] == undefined) {
        return '';
    }
    return value || typeof value === 'number' ? undefined :  langdata && langdata['required'] ? langdata['required'] : '' 

};

export const maxLength = (max: any) => (value: string) =>
    value && value.length > max ? langdata['mustbe'] == undefined ? 'Must be' : langdata['mustbe'] + `${max}` + langdata['charactersorless'] == undefined ? 'characters or less' : langdata['charactersorless'] : undefined
export const maxLength15 = maxLength(15)
export const minLength = (min: any) => (value: any) =>
    value && value.length < min ? langdata['mustbe'] == undefined ? 'Must be' : langdata['mustbe'] + `${min}` + langdata['charactersormore'] == undefined ? 'characters or more' : langdata['charactersormore'] : undefined
export const minLength2 = minLength(2)
export const number = (value: any) =>
    value && isNaN(Number(value)) ? langdata['mustbeanumber'] == undefined ? 'Must be a number' : langdata['mustbeanumber'] : undefined
export const minValue = (min: any) => (value: any) =>
    value && value < min ? langdata['mustbeatleast'] == undefined ? 'Must be at least' : langdata['mustbeatleast'] + `${min}` : undefined
export const minValue13 = minValue(13)
//export const email = (value: string) =>
//    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
//        ? langdata['invalidemail'] == undefined ? 'Invalid email address' : langdata['invalidemail']
//        : undefined
export const email = (value: string) =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? langdata && langdata['invalidemail'] ? langdata['invalidemail'] : 'Invalid email address'
        : undefined;
export const tooYoung = (value: any) =>
    value && value < 13
        ? 'You do not meet the minimum age requirement!'
        : undefined
export const aol = (value: string) =>
    value && /.+@aol\.com/.test(value)
        ? 'Really? You still use AOL for your email?'
        : undefined
export const alphaNumeric = (value: string) =>
    value && /[^a-zA-Z0-9 ]/i.test(value)
        ? 'Only alphanumeric characters'
        : undefined
/*export const phoneNumber = (value: string) =>
    value.length<10 && !/^[ A-Za-z0-9 +-.()]*$/i.test(value)
        ? 'Invalid phone number'
        : undefined*/

export const phoneNumber = (value: string) =>
    value && !/(^\d{10}$)|(^\d{11}$)|(^\d{12}$)|(^\d{13}$)|(^\d{14}$)|(^\d{15}$)/i.test(value)
        ? ((langdata['invalidphonenumbermustbe'] == undefined ? 'Invalid phone number, must be 10 digits' : langdata['invalidphonenumbermustbe']) + " 10 " + (langdata['digits'] == undefined ? "digits" : langdata['digits']))
        : undefined
export const zipCode = (value: string) =>
    value && /(^\d{8}$)|(^\d{8}-\d{4}$)/.test(value)
        ? langdata['invalidzipcode'] == undefined ? 'Invalid zipcode' : langdata['invalidzipcode']
        : undefined
export const password = (value: string) =>
    value && !/^(?=.*[0-9])(?=.*[!@#$%^&*?.])[a-zA-Z0-9!@#$%^&*?.]{6,16}$/.test(value)
        /*     ? langdata && langdata['invalidpassword'] == undefined ? 'Invalid Password' : langdata['invalidpassword']*/
        ? langdata && langdata['invalidpassword'] ? langdata['invalidpassword'] : 'Invalid Password'
        : undefined
export const matchInput = (input: string, allInputs: any) => {
   
    return input === allInputs.Password ? undefined : langdata && langdata['passwordsdonotmatch'] ? langdata['passwordsdonotmatch'] : 'Passwords do not match' ;
}


export const passwordsMustMatch = (input: any, allInputs: any) => {
    return input === allInputs.NewPassword ? undefined : langdata['passwordsdonotmatch'] == undefined ? 'Passwords do not match' : langdata['passwordsdonotmatch'];
}

export const statusColor = (status: any) => {
    //console.log(status)
    if (status === 8)
        return "badge badge-pill bg-success-light";
    else if (status === 9)
        return "badge badge-pill bg-primary-light";
    else if (status === 1)
        return "badge badge-pill bg-info-light";
    //else if (status === "InProgress")
    //    return "badge badge-pill bg-warning-light";
    else if (status === 6)
        return "badge badge-pill bg-danger-light";
    //else if (status === 5)
    //    return "badge badge-pill bg-success-light";
    else if (status === 7)
        return "badge badge-pill bg-success-light";
    else if (status === 2 || status === 5 || status === 3 )
        return "badge badge-pill bg-warning-light";
    //else if (status === 3)
    //    return "badge badge-pill bg-success-light";
    else if (status === 6)
        return "badge badge-pill bg-danger-light";
    else if (status === 11)
        return "badge badge-pill bg-secondary";
    else if (status === 12)
        return "badge badge-pill bg-primary-light";
    else
        return "badge badge-pill bg-warning-light";
}
export const transcationstatusColor = (status: any) => {
    //console.log(status)
    if (status === 10)
        return "text-warning";
    else if (status === 3)
        return "text-danger";
    else if (status === 9)
        return "text-danger";
    else
        return "text-success";
}
export const statusColorTranscation = (status: any) => {
    //console.log(status)
    if (status === 10)
        return "badge badge-pill bg-warning-light";
    else if (status === 3)
        return "badge badge-pill bg-danger-light";
    else if (status === 9)
        return "badge badge-pill bg-danger-light";
    else
        return "badge badge-pill bg-success-light";
}

export const insuranceVerificationStatusColor = (status: any) => {
    console.log(status)
    if (status === 1)
        return "badge badge-pill badge-secondary";
    else if (status === 2)
        return "badge badge-pill badge-success";
    else
        return "badge badge-pill badge-danger";
}

export const paymentstatusColor = (status: any) => {
    if (status === "Applied" || status === "Aplicada")
        return "badge badge-pill bg-success-light";
    else if (status === "Paid")
        return "badge badge-pill bg-primary-light";
    else if (status === "Scheduled")
        return "badge badge-pill bg-info-light";
    else if (status === "InProgress")
        return "badge badge-pill bg-warning-light";
    else if (status === "Cancelled")
        return "badge badge-pill bg-danger-light";
    else if (status === "ReScheduled" || status === "Re Scheduled" || status === "Re scheduled" || status === "Rescheduled")
        return "badge badge-pill bg-info-light";
    else if (status === "Checkin" || status === "CheckIn")
        return "badge badge-pill bg-success-light";
    else if (status === "Checkout")
        return "badge badge-pill bg-success-light";
    else if (status === "UnApplied")
        return "badge badge-pill bg-danger-light";
    else if (status === "Payment Pending")
        return "badge badge-pill bg-secondary";
    else
        return "badge badge-pill bg-danger-light";
}

export const dateUTCFormat = (value: any) => {
    return Moment.utc(new Date(value)).format("D MMM YYYY");

}
export const dateFormat = (value: any) => {
    if (value == null) {
        return "";
    } else {
        var langcode: any = localStorage.getItem('DefaultLangCode');
        if (langcode == "es-cr")
            Moment.locale("es-us");
        else
        Moment.locale(langcode.split("-")[0]);
        return Moment(new Date(value)).format("D MMM YYYY");
    }
}

export const dateConversion = (offset: any) => {
    var langcode: any = localStorage.getItem('DefaultLangCode');
    if (langcode == "es-cr")
        Moment.locale("es-us");
    else
    Moment.locale(langcode.split("-")[0]);
    return Moment.utc().utcOffset(+parseInt(offset || "")).format('D MMM YYYY')
}

export const timeConversion = (offset: any) => {
    return Moment.utc().utcOffset(+parseInt(offset || "")).format('LT');
}
export const dateFormatConversion = (value: any, offset: any) => {
    if (value == null) {
        return "";
    }
    else {
        var langcode: any = localStorage.getItem('DefaultLangCode');
        if (langcode == "es-cr")
            Moment.locale("es-us");
        else
        Moment.locale(langcode.split("-")[0]);
        return Moment.utc(value).utcOffset(+parseInt(offset || "")).format('D MMM YYYY')
    }
}
export const timeFormatConversion = (value: any, offset: any) => {
    if (value == null) {
        return "";
    }
    else
        return Moment.utc(value).utcOffset(+parseInt(offset || "")).format('LT');
}

export const dateFormatConvert = (value: any) => {

    return Moment.utc(value).utcOffset(+parseInt(localStorage.getItem('timeOffset') || "")).format('D MMM YYYY')
}
export const timeFormatConvert = (value: any) => {

    return Moment.utc(value).utcOffset(+parseInt(localStorage.getItem('timeOffset') || "")).format('LT')
}
export const timeFormat = (value: any) => {

    return Moment.utc(value).format('LT')
}

export const dateTimeFormat = (value: any) => {
    return Moment(new Date(value)).format("D MMM YYYY") + " " + Moment(new Date(value)).format('LT');
}

export const getAge = (dateString: any) => {
    var today = new Date();
    var birthDate = new Date(datePostFormat(dateString));
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}
export const datePostFormat = (value: any) => {
    if (localStorage.getItem("DateFormat") === "DD-MM-YYYY") {
        if (value.split('-')[0].length == 4) {
            const year = value.split('-')[0];
            const month = value.split('-')[1];
            const day = value.split('-')[2];
            const result = [month, day.split('T')[0], year].join('/');
            return Moment(new Date(result)).format("D MMM YYYY");
        }
        else if (value.split('-')[0].length == 2) {
            const [day, month, year] = value.split('-');
            const result = [month, day, year].join('/');
            return Moment(new Date(result)).format("D MMM YYYY");
        }


    } else if (localStorage.getItem("DateFormat") === "MM-DD-YYYY") {
        if (value.split('-')[0].length == 4) {
            const year = value.split('-')[0];
            const month = value.split('-')[1];
            const day = value.split('-')[2];
            const result = [month, day.split('T')[0], year].join('/');
            return Moment(new Date(result)).format("D MMM YYYY");
        }
        else if (value.split('-')[0].length == 2) {
            const [month, day, year] = value.split('-');
            const result = [month, day, year].join('/');
            return Moment(new Date(result)).format("D MMM YYYY");
        }
    } else if (localStorage.getItem("DateFormat") === "YYYY-MM-DD") {
        const [year, month, day] = value.split('-');
        const result = [month, day, year].join('/');
        return Moment(new Date(result)).format("D MMM YYYY");
    } else if (localStorage.getItem("DateFormat") === "YYYY-DD-MM") {
        const [year, day, month] = value.split('-');
        const result = [month, day, year].join('/');
        return Moment(new Date(result)).format("D MMM YYYY");
    } else if (localStorage.getItem("DateFormat") === "DD/MM/YYYY") {
        const [day, month, year] = value.split('/');
        const result = [month, day, year].join('/');
        return Moment(new Date(result)).format("D MMM YYYY");
    } else if (localStorage.getItem("DateFormat") === "MM/DD/YYYY") {
        const [month, day, year] = value.split('/');
        const result = [month, day, year].join('/');
        return Moment(new Date(result)).format("D MMM YYYY");
    } else if (localStorage.getItem("DateFormat") === "YYYY/MM/DD") {
        const [year, month, day] = value.split('/');
        const result = [month, day, year].join('/');
        return Moment(new Date(result)).format("D MMM YYYY");
    } else if (localStorage.getItem("DateFormat") === "YYYY/DD/MM") {
        const [year, day, month] = value.split('/');
        const result = [month, day, year].join('/');
        return Moment(new Date(result)).format("D MMM YYYY");
    } else {
        return value;
    }
}

export const dateFormatSetting = (value: any) => {
    //console.log(value)
    if (value != null) {
        var format: any = localStorage.getItem("DateFormat");
        Moment.locale();
        if (value == "Invalid date" || value == "Fecha inválida") {
            return ""
        }
        var date = Moment(new Date(value)).format(format);
        if (date == "Invalid date" || date == "Fecha inválida") {
            return value;
        } else {
            return date;
        }
    } else {
        return "";
    }

}
export const datemonthFormatSetting = (value: any) => {
    //console.log(value)
    if (value != null) {
        var format: any = localStorage.getItem("DateFormat");
        Moment.locale();
        if (value == "Invalid date" || value == "Fecha inválida") {
            return ""
        }
        var date = Moment(new Date(value)).format(format);
        if (date == "Invalid date" || date == "Fecha inválida") {
            return value;
        } else {
            return value;
        }
    } else {
        return "";
    }

}

export const toConvertDate = (date: any) => {
    if (date != null) {
        var inputDate: any = date;
        var parts: any = inputDate.split('-');
        var outputDate: any = parts[0] + '/' + parts[1] + '/' + parts[2];
        return outputDate; 
    }
}
export const toDate = (date: any) => {
    if (date != null) {
        var currentDateTime = new Date(date);
        return currentDateTime
    }
}
export const convertYeartoDate = (date: any) => {
// var format: any = localStorage.getItem("DateFormat");
//if (date != null) {
//    var _dateofbirth: any = datePostFormat(date);
//    const IsoDateTo = Moment(_dateofbirth, format).format('YYYY-MM-DD');
//    console.log(IsoDateTo)

//    return Moment(_dateofbirth, 'DD/MM/YYYY').format('YYYY-MM-DD');

//}
//if (date != null) {
//    var _dateofbirth: any = datePostFormat(date);
//    return Moment(new Date(_dateofbirth)).format('YYYY-MM-DD');
//    }
//if (date != null) {
//    var _dateofbirth: any = datePostFormat(date);
//    const IsoDateTo = Moment(_dateofbirth, 'DD/MM/YYYY').format('YYYY-MM-DD');
//    console.log(IsoDateTo)

//    return Moment(_dateofbirth, 'DD/MM/YYYY').format('YYYY-MM-DD');

//}
    var format: any = localStorage.getItem("DateFormat");

    if (!date) {
        return null;
    }

    const momentDate = Moment(date, format, true);

    if (!momentDate.isValid()) {
        return null;
    }

    return momentDate.format("YYYY-MM-DD");
}
export const getPageGroup = (data: any) => {
    const urlParams = new URLSearchParams(window.location.search);
    const page = urlParams.get('page');
    if (data == "consultationrequest")
        return "consultationrequest,familymember,footer,header"
    else if (data == "")
        return "homepage,footer,header"
    else if (data == "dashboard")
        return "dashboard, leftsidemenu,footer,header"
    else if (data == "profilesettings")
        return "profilesettings, leftsidemenu,footer,header"
    else if (data == "changepassword")
        return "changepassword, leftsidemenu,footer,header"
    else if (data == "insurance")
        return "addinsurance,leftsidemenu,footer,header"
    else if (data == "transactions")
        return "transactions,leftsidemenu,footer,header"   
    else if (data == "contact")
        return "profilesettings,footer,header"
    else if (data == "account")
        return "passwordretrieve,footer,header"
    else if (data == "formlist")
        return "formlist,leftsidemenu,footer,header"
    else if (data == "visitdetail")
        return "visitdetail,leftsidemenu,footer,header"
    else if (data == "paymentprocess")
        return "paymentprocessing,footer,header"
    else if (page == "privacy")
        return "privacy,footer,header"
    else if (page == "terms")
        return "terms,footer,header"
    else if (page == "refund")
        return "refund,footer,header"
    else if (page == "faq")
        return "faq,footer,header"
    else if (data == "forms")
        return "leftsidemenu,footer,header"
    else if (data == "surveyform")
        return "surveyform,footer,header"
    else if (data == "passcode")
        return "passcode,leftsidemenu,footer,header"
    else if (data == "subscription")
        return "transactions,leftsidemenu,footer,header"
    else
        return data + ",footer,header";
}
export const setTittle = (data: any) => {
    return {
        title: data,
        pageTitle: data,
        description: ''
    }
}

export const listConvertParentChild = (list: any) => {
    var map: any = {}, node, roots = [], i;
    for (i = 0; i < list.length; i += 1) {
        map[list[i].appointmentId] = i; // initialize the map
        list[i].children = []; // initialize the children
    }

    for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.parentId !== null) {
            // if you have dangling branches check that map[node.parentId] exists
            list[map[node.parentId]].children.push(node);
        } else {
            roots.push(node);
        }
    }
    return roots;
}

export const scrollTop = () => {
    setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }) }, 0)
}


export const checkFamilyMember = () => {

    if (localStorage.getItem("familymember") == "Yes") {
        if (localStorage.getItem("isAuth") != "true") {
            window.location.href = "/login"
        }
    }
}

export const isNegative = (num:any) => {
    if (Math.sign(num) === -1) {
        return true;
    }
    return false;
}
export const addMinutes = (date:any, minutes:any) => {
    date.setMinutes(date.getMinutes() + minutes);
    return date;
}

export const getParameterByName = (name: any, url: any) => {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
//let connection = new HubConnectionBuilder()
//    .withUrl("https://devsignalbuzzapp.azurewebsites.net/api")
//    .build();

//connection.on("broadcastMessage", data => {
//    console.log(data);
//});
//console.log(connection);
//connection.start()
//    .then(() => connection.invoke("send", "Hello"));

//connection.onclose(error => {
//    console.assert(connection.state === HubConnectionState.Disconnected);
//    console.log('Connection closed due to error. Try refreshing this page to restart the connection', error);
//});

//connection.onreconnecting(error => {
//    console.assert(connection.state === HubConnectionState.Reconnecting);
//    console.log('Connection lost due to error. Reconnecting.', error);
//});

//connection.onreconnected(connectionId => {
//    console.assert(connection.state === HubConnectionState.Connected);
//    console.log('Connection reestablished. Connected with connectionId', connectionId);
//});
